import { isDefined } from "@perxis-auto/shared/lib";
import { MediaFormatEnum } from "../../types/media.js";
const createMediaPath = (id, media, template, params = {}) => {
  var _a;
  const templateConfig = (_a = media.templates) == null ? void 0 : _a[template];
  if (!isDefined(templateConfig) || !isDefined(templateConfig.path)) {
    return `${media.apiRoot.replace(/\/$/, "")}/${id}`;
  }
  const resolvedParams = {
    id,
    format: MediaFormatEnum.WEBP,
    ...templateConfig.params,
    ...params
  };
  const resolvedFormat = Object.values(MediaFormatEnum).includes(resolvedParams.format) ? resolvedParams.format : MediaFormatEnum.WEBP;
  resolvedParams.format = resolvedFormat;
  const resolvedPath = templateConfig.path.replace(
    /{(\w+)}/g,
    (_, key) => isDefined(resolvedParams[key]) ? String(resolvedParams[key]) : ""
  );
  return `${media.apiRoot.replace(/\/$/, "")}/${resolvedPath.replace(/^\//, "")}`;
};
export {
  createMediaPath
};
